import { render, staticRenderFns } from "./MatchPotentialTable.vue?vue&type=template&id=d95d5d1c&scoped=true&"
import script from "./MatchPotentialTable.vue?vue&type=script&lang=js&"
export * from "./MatchPotentialTable.vue?vue&type=script&lang=js&"
import style0 from "./MatchPotentialTable.vue?vue&type=style&index=0&id=d95d5d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95d5d1c",
  null
  
)

export default component.exports